export default function Main() {
  return (
    <ul>
      <li><a href="/social-generator">Social Generator</a></li>
    </ul>
  )
}